import React, { useEffect, useState } from 'react'
import { Drawer, Card, Button, Form, Row, Col } from 'antd'
import {
  formItemLayout,
  currencyList,
  PaymentModes,
  chooseEmailModalFxn
} from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { AcceptanceAbstract } from '../actions'
import moment from 'moment'

const AcceptanceAbstractDrawer = (props) => {
  let {
    children,
    form: { getFieldDecorator, setFieldsValue },
    callback = null,
    visible,
    onClose,
    abstract,
    edit
  } = props
  const dispatch = useDispatch()

  let [visibleDrawer, setVisibleDrawer] = useState(false)

  let setFormData = () => {
    let { abstract, edit } = props
    if (!props.form) return;

    if (edit && abstract) {
      props.form.setFieldsValue({
        approvedAbstractPaymentDate: abstract.approvedAbstractPaymentDate ? moment(abstract.approvedAbstractPaymentDate) : moment(),
        // 🌟 FIX: It will now show saved payment, or fallback to publication charges!
        approvedAbstractPayment: abstract.approvedAbstractPayment || abstract.publicationCharges || '',
        currencyTypeOfApprovalAmount: abstract.currencyTypeOfApprovalAmount || 'Rs.',
        approvedAbstractPaymentMode: abstract.approvedAbstractPaymentMode || undefined,
        approvedAbstractPaymentDiscription: abstract.approvedAbstractPaymentDiscription || ''
      })
    } else {
      props.form.setFieldsValue({
        approvedAbstractPayment: abstract ? abstract.publicationCharges : '',
        currencyTypeOfApprovalAmount:abstract.currency,
        approvedAbstractPaymentDate: moment()
      })
    }
  }

  // 🌟 FIX: This guarantees the drawer populates the existing data instantly when opened
  useEffect(() => {
    if (visible || visibleDrawer) {
      setTimeout(() => {
        setFormData()
      }, 100)
    } else {
      if (props.form) props.form.resetFields()
    }
  }, [visible, visibleDrawer, abstract, edit])

  const events = {
    show: (event) => {
      setVisibleDrawer(true)
    },
    hide: (event) => {
      setVisibleDrawer(false)
    }
  }

  const inputSchema = {
    fields: [
      {
        label: 'Date',
        key: 'approvedAbstractPaymentDate',
        required: true,
        placeholder: 'Date of Enter',
        type: 'date'
      },
      {
        label: 'Amount Received',
        key: 'approvedAbstractPayment',
        placeholder: 'Amount'
      },
      {
        label: 'Currency',
        key: 'currencyTypeOfApprovalAmount',
        required: true,
        placeholder: 'Currency',
        type: 'select',
        options: currencyList,
        onChange: (e) => {
          setFieldsValue({ currencyTypeOfApprovalAmount: e })
        }
      },
      {
        label: 'Mode Of payment',
        key: 'approvedAbstractPaymentMode',
        required: true,
        type: 'select',
        options: PaymentModes,
        onChange: (e) => {
          setFieldsValue({ approvedAbstractPaymentMode: e })
        }
      },
      {
        label: 'Notes',
        key: 'approvedAbstractPaymentDiscription',
        placeholder: 'Notes',
        type: 'textArea',
        span: 24
      }
    ]
  }

  const handleSubmit = e => {
    const { form, abstract } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        chooseEmailModalFxn({
          callback: async (email) => {
            valData.fromEmail = email
            valData.abstractId = abstract._id
            valData.template = valData.approvedAbstractPayment > 0 ? 'acceptanceAbstract' : 'acceptanceAbstractWithoutCharges'

            valData.status = 'Accepted Abstract'

            let { success } = await dispatch(AcceptanceAbstract(valData))
            if (success) {
              onClose()
              dispatch({ type: 'START_LOAD_ABSTRACT' }) // Refreshing the Abstract table
              if (props.callback) {
                props.callback()
              }
              events.hide()
            }
          }
        })
      }
    })
  }

  return (
    <>
      <div onClick={() => events.show()}>
        {children}
      </div>
      <Drawer
        title={`Acceptance Abstract | Abstract No. ${abstract.abstractNo || abstract.onlineAbstractId || 'N/A'}`}
        width={'60%'}
        visible={visibleDrawer || visible}
        placement='right'
        onClose={() => {
          events.hide();
          if(onClose) onClose();
        }}>
        <Card>
          <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
            <Row gutter={16}>
              {inputSchema.fields.map((item, key) => {
                return (
                  <Col span={item.span ? item.span : 12} key={key}>
                    <GetEachFormFields getFieldDecorator={getFieldDecorator}
                                       item={item} formItemLayout={formItemLayout}/>
                  </Col>
                )
              })}
              <Col span={24}>
                <Form.Item style={{ marginTop: 40 }}>
                  <Button type='primary' htmlType='submit'>
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    </>
  )
}

const WrappedForm = Form.create()(AcceptanceAbstractDrawer)

export default WrappedForm
